import { render, staticRenderFns } from "./DeclarationPrintTable.vue?vue&type=template&id=cc30a258&"
import script from "./DeclarationPrintTable.vue?vue&type=script&lang=js&"
export * from "./DeclarationPrintTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports